import { gql } from "lib/apolloClient";
import {
  resourcePlannerFragment,
  unitPlanFeedFragment,
  resourceLibraryFragment,
} from "./UnitPlanFragments";

export const deleteUnitPlanMutation = gql`
  mutation deleteUnitPlan($id: ID!, $centralRepo: Boolean) {
    planner {
      deleteUnitPlan(input: { id: $id, centralRepo: $centralRepo })
    }
  }
`;

export const clearUnitPlanAssessmentToolMutation = gql`
  mutation clearUnitPlanAssessment($unitPlanId: ID!, $updatedBy: ID!) {
    planner {
      updateUnitPlan(
        input: {
          unitPlanId: $unitPlanId
          clearAssessmentTool: true
          updatedBy: $updatedBy
        }
      ) {
        id
        assessmentTool {
          id
        }
      }
    }
  }
`;

export const createPlannerResourceMutation = gql`
  mutation createPlannerResource($input: PlannerResourceCreateInput!) {
    planner {
      createPlannerResource(input: $input) {
        ...resourcePlannerItem
      }
    }
  }
  ${resourcePlannerFragment.resource}
`;

export const addPlannerResourceMutation = gql`
  mutation addPlannerResource(
    $createdBy: ID!
    $parentType: PLANNER_RESOURCE_PARENT_ENUM!
    $parentId: ID!
    $resourceIds: [ID!]!
  ) {
    planner {
      addPlannerResource(
        input: {
          createdBy: $createdBy
          parentType: $parentType
          parentId: $parentId
          resourceIds: $resourceIds
        }
      )
    }
  }
`;

export const updatePlannerResourceMutation = gql`
  mutation updatePlannerResource($input: PlannerResourceUpdateInput!) {
    planner {
      updatePlannerResource(input: $input) {
        warning
        response {
          ...resourcePlannerItem
        }
      }
    }
  }
  ${resourcePlannerFragment.resource}
`;

export const removePlannerResourceMutation = gql`
  mutation removePlannerResource(
    $resourceId: ID!
    $deletedBy: ID!
    $parentType: PLANNER_RESOURCE_PARENT_ENUM!
    $parentId: ID!
    $isForced: Boolean
  ) {
    planner {
      removePlannerResource(
        input: {
          resourceId: $resourceId
          deletedBy: $deletedBy
          parentType: $parentType
          parentId: $parentId
          isForced: $isForced
        }
      ) {
        warning
        response
      }
    }
  }
`;

export const copyUnitPlanMutation = gql`
  mutation copyUnitPlan(
    $input: CopyUnitPlanInput!
    $showCollaborators: Boolean! = true
    $centralRepoInput: UnitCentralRepoConfigInput
    $collaboratorsFilter: CollaboratorFilters
  ) {
    planner {
      copyUnitPlan(input: $input) {
        ...unitPlanItem
      }
    }
  }
  ${unitPlanFeedFragment.unitPlanFeed}
`;

export const copyUnitPlanMutationV2 = gql`
  mutation copyUnitPlanV2(
    $input: CopyUnitPlanInputV2!
    $showCollaborators: Boolean! = true
    $centralRepoInput: UnitCentralRepoConfigInput
    $collaboratorsFilter: CollaboratorFilters
  ) {
    planner {
      copyUnitPlanV2(input: $input) {
        ...unitPlanItem
      }
    }
  }
  ${unitPlanFeedFragment.unitPlanFeed}
`;

export const importUnitPlanMutation = gql`
  mutation importUnitPlan($input: ImportUnitPlanInput!) {
    planner {
      importUnitPlan(input: $input)
    }
  }
`;

export const importInterCurriculumUnitPlanMutation = gql`
  mutation importUnitPlan($input: InterCurriculumMultiOrgUnitPlanImportInput!) {
    planner {
      interCurriculumMultiOrgImportUnitPlan(input: $input)
      __typename
    }
  }
`;

export const bulkImportUnitPlanMutation = gql`
  mutation bulkImportUnitPlans($input: BulkImportUnitInput!) {
    planner {
      bulkCopyUnitPlan(input: $input) {
        id
      }
    }
  }
`;

export const bulkImportUnitPlanWithTemporalMutation = gql`
  mutation bulkImportUnitPlans($input: BulkImportUnitInput!) {
    planner {
      bulkImportUnitPlan(input: $input) {
        success
        workflowId
      }
    }
  }
`;

export const reorderUnitPlanMutation = gql`
  mutation reorderUnitPlan($input: UnitPlanReorderInput!) {
    planner {
      reorderUnitPlan(input: $input)
    }
  }
`;

export const importAssessmentMutation = gql`
  mutation importAssessment(
    $sourceAssessmentId: ID!
    $targetUnitPlanId: ID
    $fields: [ImportAssessmentFieldInput!]
    $academicYears: [ID!]
    $sourceOrganizationId: ID
    $targetCurriculumProgramId: ID
    $courseId: ID
    $learningCourseId: ID
    $createEntityFlowResource: Boolean
  ) {
    planner {
      importAssessment(
        input: {
          sourceAssessmentId: $sourceAssessmentId
          targetUnitPlanId: $targetUnitPlanId
          fields: $fields
          academicYears: $academicYears
          sourceOrganizationId: $sourceOrganizationId
          targetCurriculumProgramId: $targetCurriculumProgramId
          courseId: $courseId
          learningCourseId: $learningCourseId
          createEntityFlowResource: $createEntityFlowResource
        }
      ) {
        ...resourceLibraryItem
      }
    }
  }
  ${resourceLibraryFragment.resourceFeed}
`;

export const importAssessmentV2Mutation = gql`
  mutation importAssessmentV2(
    $sourceAssessmentIds: [ID!]!
    $targetUnitPlanId: ID
    $fields: [ImportAssessmentFieldInput!]
    $academicYears: [ID!]
    $sourceOrganizationId: ID
    $targetCurriculumProgramId: ID
    $courseId: ID
    $learningCourseId: ID
    $createEntityFlowResource: Boolean
  ) {
    planner {
      importAssessmentV2(
        input: {
          sourceAssessmentIds: $sourceAssessmentIds
          targetUnitPlanId: $targetUnitPlanId
          fields: $fields
          academicYears: $academicYears
          sourceOrganizationId: $sourceOrganizationId
          targetCurriculumProgramId: $targetCurriculumProgramId
          courseId: $courseId
          learningCourseId: $learningCourseId
          createEntityFlowResource: $createEntityFlowResource
        }
      ) {
        ...resourceLibraryItem
      }
    }
  }
  ${resourceLibraryFragment.resourceFeed}
`;
